
  <div 
  [ngClass]="glowClass + (capitalize ? ' capitalize' : '')"
  class="typography-title-small-bold"
>
  {{ title }}
</div>
